import type { ElementType, HTMLAttributes, ReactNode } from 'react'

// docs/specs/DESIGN-SYSTEM.md §3-4: depth comes from surface tone, so no shadow.

type CardTone = 'default' | 'warning' | 'danger'

interface CardProps extends HTMLAttributes<HTMLElement> {
  tone?: CardTone
  as?: ElementType
  children?: ReactNode
}

const TONE: Record<CardTone, string> = {
  default: 'bg-surface border-line-subtle',
  warning: 'bg-warning-soft border-warning-edge',
  danger: 'bg-danger-soft border-danger-edge',
}

export default function Card({ tone = 'default', as, className, children, ...rest }: CardProps) {
  const Tag: ElementType = as ?? 'div'
  return (
    <Tag className={`${TONE[tone]} rounded-xl border p-4${className ? ` ${className}` : ''}`} {...rest}>
      {children}
    </Tag>
  )
}
